module.exports = {
  requiredWidgetSettingProperties: [
    'whereToBuyText',
    'widgetType',
    'showPrice',
    'inStockText',
    'outOfStockText',
    'numberOfRetailers',
    'currencySymbol',
  ],
  allowedWidgetOptions: [
    'Popup',
    'Local popup',
    'List',
    'Remote popup',
    'Remote local popup',
  ],
}
